import React from "react"
import { Link, graphql, useStaticQuery } from 'gatsby'
import { Navbar, Nav } from 'react-bootstrap'
import '../styles/indexstyle.scss'
import { Helmet } from 'react-helmet'

const IndexPage = ({location}) => {
	const data = useStaticQuery(graphql`
    query {

      allContentfulAboutImages {
        edges {
          node {
            name
            image {
              file {
                url
              }
            }
          }
        }
      }
     
    }
  `)  
	return (	
    <body>
      <header id="backgroundimg">
	  	<Helmet>
		  	<title>Botond Gagyi</title>
			<meta name="description" content="Botond Gagyi is a Transylvanian painter currently living and working in Cluj-Napoca, Romania. Browse the paintings on his official page and get in touch.">
			</meta>
			<meta name="keywords" content="painting, contemporary, art, transylvanian, gagyi, botond, figurative, oil painting, emerging artist, figurative art, artwork, body, fine art">
			</meta>
        	<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
            </link>
		</Helmet>

      <Navbar collapseOnSelect expand="md">
              <Navbar.Brand href="/">
                  <div id="Botond_Gagyi_co">
                      BOTOND GAGYI
                  </div>
              </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarResponsive" />
          <Navbar.Collapse id="navbarResponsive">
              <Nav as="ul">
                  <Nav.Item as="li">
                      <Link to="/paintings" className="nav-link" activeClassName="active-nav-link">
                              PAINTINGS
                      </Link>
                  </Nav.Item>

                  <Nav.Item as="li">
                  <Link to="/about" className="nav-link" activeClassName="active-nav-link">
                          ABOUT
                  </Link>
                  </Nav.Item>
                  
                  <Nav.Item as="li">
                  <Link to="/press" className="nav-link" activeClassName="active-nav-link">
                          PRESS
                  </Link>
                  </Nav.Item>

                  <Nav.Item as="li">
                  <Link to="/contact" className="nav-link" activeClassName="active-nav-link">
                          CONTACT
                  </Link>
                  </Nav.Item>
              </Nav>
              </Navbar.Collapse>
          </Navbar>		
		
		<div id="Welcome_Im_Botond_Gagyi_and_I_">
			<span>Welcome</span>
		</div>
		<a href="/about" id="CTA_-_who">
			<svg class="Rectangle_4_cj">
				<rect id="Rectangle_4_cj" rx="0" ry="0" x="0" y="0" width="250" height="60">
				</rect>
			</svg>
				<img id="Mask_Group_1" src={`Mask_Group_1.png`} alt="Mask group">
				</img>
			
			<div class="emptySpacing">
			</div>
			<div>
				<span>who is botond?</span>
			</div>
		</a>

		<div id="instaHeaderContainer">
            <a id="instaLogoHeader" class="fa fa-instagram" href="https://www.instagram.com/gagyi.botond"></a>
        </div>
		<div id="facebookHeaderContainer">
			<a id="facebookLogoHeader" class="fa fa-facebook" href="https://www.facebook.com/gagyi.botond"></a>
		</div>

      </header>
      <div id="Home">
        <div id="ID05_Footer" class="05_Footer"> 
		  <svg class="Rectangle_313">
            <rect id="Rectangle_313" rx="0" ry="0" x="0" y="0" width="1920" height="40">
            </rect>
          </svg>
          <svg class="Rectangle_6">
            <rect id="Rectangle_6" rx="0" ry="0" x="0" y="0" width="1920" height="300">
            </rect>
          </svg>
          <div id="home">
		  	<a class="nodecorationforlinks" href="/">home</a> 
          </div>
          <div id="paintings">
		  	<a class="nodecorationforlinks" href="/paintings">paintings</a> 
          </div>
          <div id="about">
		  	<a class="nodecorationforlinks" href="/about">about</a> 
          </div>
          <div id="press">
			<a class="nodecorationforlinks" href="/press">press</a> 
          </div>
          <div id="contact">
		  	<a class="nodecorationforlinks" href="/contact">contact</a> 
          </div>
          <div id="insta_icon">
		  	<a href="https://www.instagram.com/gagyi.botond/">	

				<svg class="Rectangle_2">
				<rect id="Rectangle_2" rx="0" ry="0" x="0" y="0" width="30" height="30">
				</rect>
				</svg>
				<div id="insta_icon_v">
					<svg class="Path_1" viewBox="4.079 4.079 20 20">
						<path id="Path_1" d="M 14.07899951934814 5.880834579467773 C 16.74912261962891 5.880834579467773 17.06537437438965 5.89099645614624 18.11983108520508 5.939106464385986 C 19.09481811523438 5.983604907989502 19.62430953979492 6.146512508392334 19.97672271728516 6.283420562744141 C 20.44345664978027 6.464826583862305 20.77657508850098 6.681561470031738 21.12652778625488 7.031472682952881 C 21.47643852233887 7.381423950195313 21.69317245483398 7.71454381942749 21.87458038330078 8.181278228759766 C 22.01148796081543 8.533650398254395 22.17439460754395 9.06318187713623 22.21889495849609 10.03812980651855 C 22.26700401306152 11.09262657165527 22.27716445922852 11.40887641906738 22.27716445922852 14.07899951934814 C 22.27716445922852 16.74912261962891 22.26700401306152 17.06537437438965 22.21889495849609 18.11983108520508 C 22.17439460754395 19.09481811523438 22.01148796081543 19.62430953979492 21.87458038330078 19.97672271728516 C 21.69317245483398 20.44345664978027 21.47643852233887 20.77657508850098 21.12652778625488 21.12652778625488 C 20.77657508850098 21.47643852233887 20.44345664978027 21.69317245483398 19.97672271728516 21.87458038330078 C 19.62430953979492 22.01148796081543 19.09481811523438 22.17439460754395 18.11983108520508 22.21889495849609 C 17.06553077697754 22.26700401306152 16.74928283691406 22.27716445922852 14.07899951934814 22.27716445922852 C 11.40871810913086 22.27716445922852 11.09246826171875 22.26700401306152 10.03816986083984 22.21889495849609 C 9.06318187713623 22.17439460754395 8.533650398254395 22.01148796081543 8.181278228759766 21.87458038330078 C 7.71454381942749 21.69317245483398 7.381423950195313 21.47643852233887 7.031472682952881 21.12652778625488 C 6.681561470031738 20.77661514282227 6.464826583862305 20.44345664978027 6.283420562744141 19.97672271728516 C 6.146512508392334 19.62430953979492 5.983604907989502 19.09481811523438 5.939106464385986 18.11986923217773 C 5.89099645614624 17.06537437438965 5.880834579467773 16.74912261962891 5.880834579467773 14.07899951934814 C 5.880834579467773 11.40887641906738 5.89099645614624 11.09262657165527 5.939106464385986 10.03816986083984 C 5.983604907989502 9.06318187713623 6.146512508392334 8.533650398254395 6.283420562744141 8.181278228759766 C 6.464826583862305 7.71454381942749 6.681561470031738 7.381423950195313 7.031472682952881 7.031472682952881 C 7.381423950195313 6.681561470031738 7.71454381942749 6.464826583862305 8.181278228759766 6.283420562744141 C 8.533650398254395 6.146512508392334 9.06318187713623 5.983604907989502 10.03812980651855 5.939106464385986 C 11.09262657165527 5.89099645614624 11.40887641906738 5.880834579467773 14.07899951934814 5.880834579467773 M 14.07899951934814 4.078999519348145 C 11.36314868927002 4.078999519348145 11.02260494232178 4.090511322021484 9.95604133605957 4.139177322387695 C 8.891619682312012 4.187764167785645 8.164724349975586 4.356784820556641 7.528613567352295 4.604005336761475 C 6.871026515960693 4.859561443328857 6.313351154327393 5.201494216918945 5.757422924041748 5.757422924041748 C 5.201494216918945 6.313351154327393 4.859561443328857 6.871026515960693 4.604005336761475 7.528613567352295 C 4.356784820556641 8.164724349975586 4.187764167785645 8.891619682312012 4.139177322387695 9.95604133605957 C 4.090511322021484 11.02260494232178 4.078999519348145 11.36314868927002 4.078999519348145 14.07899951934814 C 4.078999519348145 16.79485130310059 4.090511322021484 17.13539505004883 4.139177322387695 18.20195960998535 C 4.187764167785645 19.26638031005859 4.356784820556641 19.9932746887207 4.604005336761475 20.62938690185547 C 4.859561443328857 21.28693389892578 5.201494216918945 21.84465026855469 5.757422924041748 22.40057754516602 C 6.313351154327393 22.95650672912598 6.871026515960693 23.29843711853027 7.528613567352295 23.55399513244629 C 8.164724349975586 23.80121803283691 8.891619682312012 23.97023773193359 9.95604133605957 24.01882362365723 C 11.02260494232178 24.06748962402344 11.36314868927002 24.07900047302246 14.07899951934814 24.07900047302246 C 16.79485130310059 24.07900047302246 17.13539505004883 24.06748962402344 18.20195960998535 24.01882362365723 C 19.26638031005859 23.97023773193359 19.9932746887207 23.80121803283691 20.62938690185547 23.55399513244629 C 21.28697395324707 23.29843711853027 21.84465026855469 22.95650672912598 22.40057754516602 22.40057754516602 C 22.95650672912598 21.84465026855469 23.29843711853027 21.28697395324707 23.55399513244629 20.62938690185547 C 23.80121803283691 19.9932746887207 23.97023773193359 19.26638031005859 24.01882362365723 18.20195960998535 C 24.06748962402344 17.13539505004883 24.07900047302246 16.79485130310059 24.07900047302246 14.07899951934814 C 24.07900047302246 11.36314868927002 24.06748962402344 11.02260494232178 24.01882362365723 9.95604133605957 C 23.97023773193359 8.891619682312012 23.80121803283691 8.164724349975586 23.55399513244629 7.528613567352295 C 23.29843711853027 6.871026515960693 22.95650672912598 6.313351154327393 22.40057754516602 5.757422924041748 C 21.84465026855469 5.201494216918945 21.28697395324707 4.859561443328857 20.62938690185547 4.604005336761475 C 19.9932746887207 4.356784820556641 19.26638031005859 4.187764167785645 18.20195960998535 4.139177322387695 C 17.13539505004883 4.090511322021484 16.79485130310059 4.078999519348145 14.07899951934814 4.078999519348145 L 14.07899951934814 4.078999519348145 Z">
						</path>
					</svg>
					<svg class="Path_2" viewBox="126.635 126.635 10.489 10.489">
						<path id="Path_2" d="M 131.8795166015625 126.6350021362305 C 128.9830780029297 126.6350021362305 126.6350021362305 128.9830780029297 126.6350021362305 131.8795166015625 C 126.6350021362305 134.7759552001953 128.9830780029297 137.1240234375 131.8795166015625 137.1240234375 C 134.7759552001953 137.1240234375 137.1240234375 134.7759552001953 137.1240234375 131.8795166015625 C 137.1240234375 128.9830780029297 134.7759552001953 126.6350021362305 131.8795166015625 126.6350021362305 Z M 131.8795166015625 135.2838134765625 C 129.9993743896484 135.2838134765625 128.4751739501953 133.7596588134766 128.4751739501953 131.8795166015625 C 128.4751739501953 129.9993743896484 129.9993743896484 128.4751739501953 131.8795166015625 128.4751739501953 C 133.7596588134766 128.4751739501953 135.2838592529297 129.9993743896484 135.2838592529297 131.8795166015625 C 135.2838592529297 133.7596588134766 133.7596588134766 135.2838134765625 131.8795166015625 135.2838134765625 Z">
						</path>
					</svg>
					<svg class="Ellipse_1">
						<ellipse id="Ellipse_1" rx="1.173020839691162" ry="1.173020839691162" cx="1.173020839691162" cy="1.173020839691162">
						</ellipse>
					</svg>
            	</div>
			</a>
        </div>
		<div id="FB_icon">
			<a href="https://www.facebook.com/gagyi.botond">	
				<svg class="Rectangle_3">
					<rect id="Rectangle_3" rx="0" ry="0" x="0" y="0" width="30" height="30">
					</rect>
				</svg>
				<svg class="Path_108" viewBox="0 0 20 19.878">
					<path id="Path_108" d="M 20 10.00000095367432 C 20 4.47714900970459 15.52285194396973 0 10 0 C 4.47714900970459 0 0 4.47714900970459 0 10.00000095367432 C 0 14.99128913879395 3.656855344772339 19.12832260131836 8.437500953674316 19.87847518920898 L 8.437500953674316 12.89062595367432 L 5.8984375 12.89062595367432 L 5.8984375 10.00000095367432 L 8.437500953674316 10.00000095367432 L 8.437500953674316 7.796874523162842 C 8.437500953674316 5.290625095367432 9.930449485778809 3.90625 12.21462917327881 3.90625 C 13.30875110626221 3.90625 14.45312404632568 4.1015625 14.45312404632568 4.1015625 L 14.45312404632568 6.562500476837158 L 13.19213008880615 6.562500476837158 C 11.94990158081055 6.562500476837158 11.5625 7.333340644836426 11.5625 8.124160766601563 L 11.5625 10.00000095367432 L 14.33593654632568 10.00000095367432 L 13.89257621765137 12.89062595367432 L 11.5625 12.89062595367432 L 11.5625 19.87847518920898 C 16.34314346313477 19.12832260131836 20 14.99128913879395 20 10.00000095367432 Z">
					</path>
				</svg>
			</a>
      	</div>
		<div id="Botond_Gagyi">
        	<span>Botond Gagyi</span>
		</div>
		<div id="all_rights_reserved_2020">
			<span>all rights reserved ©2020</span>
		</div>
		<div id="If_you_want_to_talk">
			<span></span>
		</div>
		<div id="instaFooterContainer">
			<a id="instaLogoFooter" class="fa fa-instagram" href="https://www.instagram.com/gagyi.botond"></a>
		</div>
		<div id="facebookFooterContainer">
			<a id="facebookLogoFooter" class="fa fa-facebook" href="https://www.facebook.com/gagyi.botond"></a>
		</div>

		<a href="/contact" id="bfbf">
			<svg class="Rectangle_4_bfbf">
				<rect id="Rectangle_4_bfbf" rx="0" ry="0" x="0" y="0" width="250" height="60">
				</rect>
			</svg>

			<div class="emptySpacing">
			</div>
			<div>
				<span>contact me</span>
			</div>
		</a>
      </div>

	  <div id="ID04_Expos">
		<img id="painting" src={`painting.jpg`} alt="painting">
		</img>
		<div id="Exhibition_Name_and_year">
			<span>StartPoint Prize 2017, Prize<br></br>for European Art Graduates,<br></br> Trade Fair Palace,<br></br> Prague National Gallery</span>
		</div>
		<div id="Exhibition_Name_and_year_dummy">
			StartPoint Prize 2017, Prize for European Art Graduates, Trade Fair Palace,Prague National Gallery
		</div>
		<div id="Exhibition_description_in_2-3_">
			<span>The largest and most prestigious competition for the graduates of european art academies. The StartPoint Prize is a unique not only for its long tradition and span, but also for it's independence, where the academies hold only a minority consulting vote. It does not even determine the medium, technique of there. The most important criterion is the novelty and originality, It's main purpose lies in finding a fresh look at the most recent emerging art across Europe and in it's promotion and popularization.</span>
		</div>
		<a id="CTA_-_all_my_expos" href="/about#Biography">
			<svg class="Rectangle_4_bf">
				<rect id="Rectangle_4_bf" rx="0" ry="0" x="0" y="0" width="250" height="60">
				</rect>
			</svg>
			<div class="emptySpacing"></div>
			<div>
				<span>all my expos</span>
			</div>
		</a>
		<svg class="Rectangle_319">
			<rect id="Rectangle_319" rx="0" ry="0" x="0" y="0" width="1920" height="950">
			</rect>
		</svg>
	</div>


	<div id="ID03_Favorits">
		<svg class="Rectangle_318">
			<rect id="Rectangle_318" rx="0" ry="0" x="0" y="0" width="1920" height="950">
			</rect>
		</svg>
  
    <div id="Some_of_my_personal_favorits">
			<span>Some of my personal favourites</span>
		</div>
		<a id="CTA_-_full_portfolio" href="/paintings">				
			<svg class="Rectangle_4_bn">
				<rect id="Rectangle_4_bn" rx="0" ry="0" x="0" y="0" width="250" height="60">
				</rect>
			</svg>
			<div class="emptySpacing"></div>
			<div>
				<span>full portfolio</span>
			</div>
		</a>
  
		<div id="Painting_1">
			<div id="Siesta_oil_on_canvas__150_x_13">
				<span class="paintingTitleIndexPage">Siesta<br></br></span><span>oil on canvas | 150 x 130 cm<br></br>2020</span>
			</div>
			<img id="ID150x130_cm__oil_on_canvas__2" src={`ID150x130_cm__oil_on_canvas__2.png`} alt= "ID canvas"/>
				
			<svg class="Rectangle_314">
				<rect id="Rectangle_314" rx="0" ry="0" x="0" y="0" width="452" height="478">
				</rect>
			</svg>
		</div>

		<div id="Painting_2">
			<div id="Conquistador_oil_on_canvas__15">
				<span class="paintingTitleIndexPage">Conquistador<br></br></span><span>oil on canvas | 155 x 125 cm<br></br>2020</span>
			</div>
			<img id="Conquistador__155x125_cm__oil_" src={data.allContentfulAboutImages.edges[1].node.image.file.url} alt="Conquistador"/>
				
			<svg class="Rectangle_315">
				<rect id="Rectangle_315" rx="0" ry="0" x="0" y="0" width="309" height="478">
				</rect>
			</svg>
		</div>
		<div id="Painting_3">
			<div id="Mystic_river_oil_on_canvas__15">
				<span class="paintingTitleIndexPage">Silence<br></br></span><span>oil on canvas | 50 x 40 cm<br></br>2020</span>
			</div>
			<img id="Mystic_river__150x120_cm__oil_" src={data.allContentfulAboutImages.edges[0].node.image.file.url} alt="Mystic"/>
				
			<svg class="Rectangle_316">
				<rect id="Rectangle_316" rx="0" ry="0" x="0" y="0" width="489" height="478">
				</rect>
			</svg>
		</div>
		<div id="Painting_4">
			<div id="Showtime_oil_on_canvas__50_x_4">
				<span class="paintingTitleIndexPage">Showtime<br></br></span><span>oil on canvas | 50 x 40 cm<br></br>2020</span>
			</div>
			<img id="Showtime__50_x_40_cm__oil_on_c" src={`showtime.jpg`} alt="Showtime"/>
				
			<svg class="Rectangle_317">
				<rect id="Rectangle_317" rx="0" ry="0" x="0" y="0" width="320" height="478">
				</rect>
			</svg>
		</div>
	</div>
    <div id="ID02_About">
		<svg class="Rectangle_5">
			<rect id="Rectangle_5" rx="0" ry="0" x="0" y="0" width="1200" height="950">
			</rect>
		</svg>
		<svg class="Rectangle_320">
			<rect id="Rectangle_320" rx="0" ry="0" x="0" y="0" width="1920" height="950">
			</rect>
		</svg>
		<img id="portrait_2" src={`portrait_2.png`} alt="portrait 2">
	  	</img>

		<div id="My_name_is__Botond_Gagyi_I_con">
		<span id="indexAbout1"></span><br></br><span>I am a painter of Transylvanian origin, born in Târgu-Mureș (Romania) and currently  living and working in Cluj-Napoca where I studied Fine Arts at the University of Art and Design. There I was first awarded the degree of Bachelor of Arts, 2015, followed by Master of Arts, 2017, both within the School of Painting. Presently I am attending the same university where I am studying for a doctorate. As a result of exhibiting in several group exhibitions, not only in my own country, Romania, but also abroad, I have had the opportunity of showcasing my work in a number of solo exhibitions.  A winner of a series of exhibitions organised in 2017, I was invited to exhibit my paintings in the Trade Fair Palace of the National Gallery Prague in the Czech Republic. This event, in the framework of the StartPoint Prize 2017, is designed specifically  for European art graduates. My work is held in private collections within Europe and beyond.</span>		
	</div>
		
		<a href="/paintings" class="CTA_-_my_work">
			<svg class="Rectangle_4_cd">
				<rect id="Rectangle_4_cd" rx="0" ry="0" x="0" y="0" width="250" height="60">
				</rect>
			</svg>
			<div class="emptySpacing"></div>
			<div>
				<span>my work</span>
			</div>
		</a>
    </div>
	</div>
  </body>
    )
}

export default IndexPage